class MobileMenu extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    document
      .querySelector('#mobile-menu-button')
      .addEventListener('click', () => {
        this.openMenu()
      })

    this.addEventListener('click', (e) => {
      if (
        e.target.classList == this.classList ||
        e.target.id == 'mobile-menu-button-close'
      ) {
        this.closeMenu()
      }
    })

    // Close menu on Escape key press for keyboard accessibility
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('left-0')) {
        this.closeMenu()
        document.querySelector('#mobile-menu-button').focus()
      }
    })
  }

  openMenu() {
    this.classList.add('left-0')
    this.classList.remove('-left-full')
    this.querySelector('.mobile-menu-inner').classList.add('block')
    this.querySelector('.mobile-menu-inner').classList.remove('hidden')
    document.querySelector('body').classList.add('overflow-hidden')
    document.querySelector('#mobile-menu-overlay').classList.add('flex')
    document.querySelector('#mobile-menu-overlay').classList.remove('hidden')

    // Add inert attribute to elements outside the mobile menu for focus trapping (WCAG 2.4.3)
    document.querySelector('#MainContent')?.setAttribute('inert', '')
    document.querySelector('footer')?.setAttribute('inert', '')
    document.querySelector('sticky-cart-icon')?.setAttribute('inert', '')
    document.querySelector('.header-wrap main-header')?.setAttribute('inert', '')

    // Move focus to the close button for proper focus management
    setTimeout(() => {
      this.querySelector('#mobile-menu-button-close')?.focus()
    }, 100)
  }

  closeMenu() {
    this.classList.remove('left-0')
    this.classList.add('-left-full')
    document.querySelector('body').classList.remove('overflow-hidden')
    setTimeout(() => {
      this.querySelector('.mobile-menu-inner').classList.add('hidden')
      this.querySelector('.mobile-menu-inner').classList.remove('block')
    }, 200)
    document.querySelector('#mobile-menu-overlay').classList.remove('flex')
    document.querySelector('#mobile-menu-overlay').classList.add('hidden')

    // Remove inert attribute from elements outside the mobile menu
    document.querySelector('#MainContent')?.removeAttribute('inert')
    document.querySelector('footer')?.removeAttribute('inert')
    document.querySelector('sticky-cart-icon')?.removeAttribute('inert')
    document.querySelector('.header-wrap main-header')?.removeAttribute('inert')
  }
}

customElements.define('mobile-menu', MobileMenu)
